export const IN_VIEW_PERCENTAGE = 50;
export const INTERVAL_TILL_HOVER = 1000;
export const IN_VIEW_WAIT_TIME = 1000;



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Render/tracking/constants/index.js